import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import formatCurrency from '../../../shared/utils/formatCurrency';
import integerWithCommas from '../../../shared/utils/integerWithCommas';
import styles from '../report.module.scss';
import { accountSelector } from '../../../shared/store/shared/accountSlice';
import CertificationDetails from './CertificationDetails';
import MembershipDetails from './MembershipDetails';
import CoursesDetails from './CoursesDetails';
import DigitalProductDetails from './DigitalProductDetails';
import { ProductReport } from '../../../shared/models/ReportModel';
import { ProductTypes } from '../../../shared/constants';

interface CardProps {
  data: ProductReport[];
  dealId: string;
  reportType: string;
  isPayByUser: boolean;
}

export default function OverviewMobileView({
  data,
  dealId,
  reportType,
  isPayByUser,
}: CardProps) {
  const { currentAccountId } = useSelector(accountSelector);

  return (
    <>
      {data.map((product) => (
        <div key={product.sku} className={`${styles.cardContainer} mb-3`}>
          <div className="p-3" key={product.sku}>
            <div className={styles.productNameCell}>
              <Link
                className="accent-link"
                to={`/admin/${currentAccountId}/reports/deal/${dealId}/sku/${product.sku}/${reportType}`}
              >
                <span
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: product.name }}
                />
              </Link>
            </div>
            <div className={`${styles.commonStyles} mb-4`}>
              SKU: {product.sku}
            </div>
            <div className={`d-flex mb-3 ${styles.sectionDivider}`}>
              <div className={`${styles.commonStyles}`}>Total Spent</div>
              <div
                className={`d-flex justify-content-end ${styles.commonStyles} ${styles.valueStyles}`}
                style={{ width: '100%' }}
              >
                {`$${formatCurrency(product.priceRedeemed)}`}
              </div>
            </div>
            {!isPayByUser && (
              <div className={`d-flex mb-3 ${styles.sectionDivider}`}>
                <div className={`${styles.commonStyles}`}>Total Quantity</div>
                <div
                  className={`d-flex justify-content-end ${styles.commonStyles} ${styles.valueStyles}`}
                  style={{ width: '100%' }}
                >
                  {integerWithCommas(product.quantityTotal)}
                </div>
              </div>
            )}
            <div>
              {product.type === 'Certification' && (
                <CertificationDetails
                  product={product}
                  isPayByUser={isPayByUser}
                />
              )}
              {(product.type === ProductTypes.membership ||
                product.type === 'Chapter Membership') && (
                <MembershipDetails
                  product={product}
                  isPayByUser={isPayByUser}
                />
              )}
              {product.type === 'eLearning' && (
                <CoursesDetails product={product} isPayByUser={isPayByUser} />
              )}
              {product.type === 'Digital Product' && (
                <DigitalProductDetails
                  product={product}
                  isPayByUser={isPayByUser}
                />
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
